import { MockedInputWrapper } from './mocked-input.styles';

export const ReadOnlyValue = (props: any) =>
    props?.value ? (
        <MockedInputWrapper tabIndex={0} {...props}>
            {props.value.label}
        </MockedInputWrapper>
    ) : null;
